export default __webpack_public_path__ + "static/media/NCPL.9eceb8fe.png";